import React from 'react';
import HomePage from '../components/Views/HomePage';
import Layout from '../components/Layout/Layout';

import { getSeoData } from '../utils/helpers';
import initApollo from '../utils/init-Apollo';

import { getInitialItems, getCombinedHomePageData } from '../api/queries';

import { REVALIDATE_SECONDS, ITEMS_LIMIT } from '../utils/constants/homePage';

import { extractApolloState } from '../utils/helpers/extractApolloState';

const App = props => <HomePage {...props} />;

export async function getStaticProps({ locale }) {
  const apolloClient = initApollo({}, { lang: locale });

  try {
    const [seoData] = await Promise.all([
      getSeoData(apolloClient),

      apolloClient.query({
        query: getCombinedHomePageData
      }),

      apolloClient.query({
        query: getInitialItems,
        variables: {
          limit: ITEMS_LIMIT,
          offset: 0
        }
      })
    ]);

    return extractApolloState(apolloClient, {
      props: {
        seoData,
        currentLang: locale,
        error: false
      },

      revalidate: REVALIDATE_SECONDS
    });
  } catch (error) {
    console.error('Homepage SSG failed:', error);

    return {
      props: {
        seoData: null,
        apolloState: {},
        currentLang: locale || 'az',
        error: true
      },
      revalidate: 10
    };
  }
}

App.getLayout = (page, pageProps) => (
  <Layout pageProps={pageProps} isHomePage isBanner isBackgroundBanner>
    {page}
  </Layout>
);

export default App;
